<div mat-dialog-title class="d-flex row">
  <h2>{{ data.title }}</h2>
  <button class="ml-auto" mat-button (click)="onNoClick()" *ngIf="data.totalProgress === 100">
    <mat-icon fontIcon="fa-times"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="d-flex flex-column">
  <mat-list *ngIf="data.statusItems">
    <mat-list-item *ngFor="let item of data.statusItems; trackBy: getIdentifierForIterableItem">
      <div class="modal-status-icon {{item.status}}">
        <mat-icon class="fa {{ item.status }}"
                  style="font-size: 20px;"
                  [ngClass]="{
                      'fa-check-square-o mat-primary': item.status === 'success',
                      'fa-circle-o-notch mat-accent': item.status === 'waiting',
                      'fa-exclamation mat-warn': item.status === 'error',
                      'fa-exclamation-circle': !item.status
                  }"></mat-icon>
      </div>
      <p>{{ item.title }}</p>
    </mat-list-item>
  </mat-list>

  <div class="progress-text" [ngClass]="{ 'mat-warn': data.hasError }">{{ data.totalProgress }}%</div>
  <mat-progress-bar mode="determinate"
                    value="{{ data.totalProgress }}"
                    [ngClass]="{'mat-warn': data.hasError}"></mat-progress-bar>
</div>

<div mat-dialog-actions *ngIf="data.buttons.length" class="row no-gutters justify-content-center">
  <button (click)="button.execute()"
          *ngFor="let button of data.buttons; trackBy: getIdentifierForIterableItem"
          class="mat-primary mat-button m-h"
          color="primary"
          mat-raised-button>{{ button.title | uppercase }}</button>
</div>
